import { Component, OnInit } from '@angular/core';
import { AppLanguage, LANGUAGE_OPTIONS, LanguageService } from '../../core/util/language.service';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.css'],
})
export class LanguageSwitcherComponent implements OnInit {
  readonly languages = LANGUAGE_OPTIONS;

  currentLang: AppLanguage = 'es';

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.currentLang = this.languageService.getCurrentLanguage();
    this.languageService.languageChanges.subscribe(lang => {
      this.currentLang = lang;
    });
  }

  onLanguageChange(value: string): void {
    const lang = value as AppLanguage;
    if (lang === this.currentLang) {
      return;
    }
    void this.languageService.setLanguage(lang);
  }
}
